import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

import { ReactNode } from 'react';

interface LayoutProps {
  onLogout: () => void;
  children?: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ onLogout, children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <div className="flex flex-col flex-1 overflow-hidden">
        <TopBar onMenuClick={() => setSidebarOpen(true)} onLogout={onLogout} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;